import { createContext, useContext } from "@wordpress/element";
import { Context, Dispatch, SetStateAction } from "react";

// Type pour les valeurs de l’objet de filtre
export type FiltersValue = {
  date?: string;
  categorie?: string;
  lieu?: string;
  type_spectacle?: string;
};

// Type pour notre context, avec une valeur et un setter
type ContextWithSetter = Context<{
  filters: FiltersValue;
  setFilters: null | Dispatch<SetStateAction<FiltersValue>>;
}>;

// @ts-ignore
export const FiltersContext: ContextWithSetter = createContext({
  filters: {},
  setFilters: null,
});

// Export du composant Provider pour notre contexte
export const FiltersProvider = FiltersContext.Provider;

// Définition du hook useFilters,
// qui permet d'utiliser facilement notre contexte.
export const useFilters = () => {
  const { filters, setFilters } = useContext(FiltersContext);
  if (setFilters === null)
    throw new Error("useFilters must be used within a FiltersProvider");
  return { filters, setFilters };
};
